import React from 'react';
import convertToDollar from "./utils/convertToDollar";

const PassoverMenuItem = React.memo(({
        id,
        updateQuantity,
        quantity,
        name, 
        price, 
        unit
    }) => {


    const handleIncrease = (event) => {
        event.preventDefault();
        updateQuantity({ add: true }, id);
    }

    const handleDecrease = (event) => {
        event.preventDefault();
        if (quantity > 0) {
            updateQuantity({ add: false }, id);
        }
    }

    return (
        <li className={`passover-menu-list-item ${(quantity > 0) ? 'selected' : ''}`}>
            <div className="passover-menu-list-item-name">{name}</div>
            <div className="passover-menu-list-item-price">{convertToDollar(price)} {unit}</div>
            <div className="passover-menu-list-item-quantity">
                <button className="menu-button menu-button-add" onClick={handleIncrease}>
                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                </button>
                <div>{quantity}</div>
                <button className="menu-button menu-button-subtract" disabled={quantity === 0} onClick={handleDecrease}>
                    <i className="fa fa-minus-circle" aria-hidden="true"></i>
                </button>
            </div>
        </li>
    )
});

export default PassoverMenuItem;
